import { IonIcon, IonItem } from '@ionic/react'

interface Props {
  href: string
  icon: string
  label: string
  enabled: boolean
}

const ProcedureLink = ({ href, icon, label, enabled }: Props) => {
  return (
    <IonItem className="item-tramites" routerDirection="forward" routerLink={href} disabled={!enabled}>
      <IonIcon className="icon-tramites" style={{ rotateX: 90 }} icon={icon} slot="start" />
      {label}
    </IonItem>
  )
}

export default ProcedureLink
